(function (global) {
    'use strict';

    global.MeloApps = global.MeloApps || {};

    function normalize(value) {
        return String(value || '')
            .toLowerCase()
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '')
            .trim();
    }

    /**
     * Application service — use cases for mini apps.
     * Depends on MeloAppsRepository only (not on mock vs API).
     *
     * @param {import('../domain/melo-app.entity').MeloAppsRepository} repository
     */
    function MeloAppsService(repository) {
        this.repository = repository;

        this.getAllApps = function () {
            return this.repository.getAll();
        };

        this.getAppBySlug = function (slug) {
            return this.repository.getBySlug(slug);
        };

        this.getHomeListApps = function () {
            return this.repository
                .getAll()
                .filter(function (app) {
                    return app.showInHomeList !== false;
                })
                .sort(function (a, b) {
                    return (a.homeListOrder || 99) - (b.homeListOrder || 99);
                });
        };

        this.getRelatedApps = function (excludeSlug) {
            return this.repository.getAll().filter(function (app) {
                return app.showInRelated !== false && app.slug !== excludeSlug;
            });
        };

        this.getSearchableApps = function () {
            return this.repository.getAll().filter(function (app) {
                return app.showInSearch !== false;
            });
        };

        this.searchApps = function (query) {
            var stopWords = ['de', 'la', 'el', 'en', 'un', 'una', 'los', 'las', 'y', 'o', 'a'];
            var terms = normalize(query)
                .split(/\s+/)
                .filter(function (term) {
                    return term && stopWords.indexOf(term) === -1;
                });

            if (!terms.length) {
                return [];
            }

            return this.getSearchableApps().filter(function (app) {
                var haystack = normalize(app.searchKeywords + ' ' + app.title + ' ' + app.shortDescription);

                return terms.every(function (term) {
                    return haystack.indexOf(term) !== -1;
                });
            });
        };
    }

    global.MeloApps.MeloAppsService = MeloAppsService;
})(typeof window !== 'undefined' ? window : global);
